import { z } from 'zod/v4'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat.js'
import relativeTime from 'dayjs/plugin/relativeTime.js'
import 'dayjs/locale/en-au.js'

export const zDayJs = z.coerce.date().transform((val) => {
    dayjs.extend(localizedFormat)
    dayjs.extend(relativeTime)
    dayjs.locale('en-au')

    return dayjs(val)
})
